import { CheckboxFilter } from '@lifebit-ai/lds'
import React from 'react'

import type { Option } from 'modules/types'
import { useGetWorkspacesFromExportRequests } from 'services/results/hooks/useGetWorkspacesFromExportRequests'

interface WorkspacesFilterProps {
  onApply: (filteredOptions: Option[]) => void
  onReset: () => void
}

export const WorkspacesFilter = ({ onApply, onReset }: WorkspacesFilterProps) => {
  const getWorkspacesFromExportRequestsQuery = useGetWorkspacesFromExportRequests()

  const options =
    getWorkspacesFromExportRequestsQuery.data?.data.map(item => ({
      label: item.name,
      value: item._id
    })) ?? []

  return (
    <CheckboxFilter
      label="Workspaces"
      loading={getWorkspacesFromExportRequestsQuery.isLoading}
      onApply={onApply}
      options={options}
      onReset={onReset}
      searchFieldPlaceholder="Search workspaces"
    />
  )
}
